import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  containerStyle: {
    width: 650,
    backgroundColor: '#FFF',
    paddingBottom: 15,
  },
  closeButton: {
    width: 40,
    height: 40,
    borderRadius: 8,
    backgroundColor: '#F5F7F8',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 30,
    right: 30,
    border: 'none',
    zIndex: 10,
  },
  mainContent: {
    alignItems: 'center',
    paddingTop: 37,
    paddingHorizontal: 120,
  },
  title: {
    fontSize: 28,
    color: '#003353',
    fontWeight: '600',
    lineHeight: 36,
    marginTop: 40,
    textAlign: 'center',
  },
  subtitle: {
    textAlign: 'center',
    fontSize: 18,
    color: '#668598',
    fontWeight: '600',
    lineHeight: 26,
    marginTop: 26,
    marginBottom: 57,
  },
  subtitleBold: {
    textAlign: 'center',
    fontSize: 18,
    color: '#668598',
    fontWeight: '700',
  },
  footerContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  deleteBtn: {
    minWidth: 224,
    minHeight: 56,
    borderRadius: 4,
    backgroundColor: 'rgba(218, 81, 94, 0.03)',
    borderWidth: 1,
    borderColor: '#DA515E',
  },
  deleteLabel: {
    fontSize: 18,
    fontWeight: '700',
    color: '#DA515E',
    lineHeight: 24,
  },
  goBackBtn: {
    minWidth: 224,
    minHeight: 56,
    borderRadius: 4,
    backgroundColor: '#00A0F3',
    marginLeft: 20,
  },
  goBackLabel: {
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 24,
    color: '#FFF',
  },
})
